import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SIZE, ORIENTATION } from '../constants';
export class PagePattern extends React.PureComponent {
    render() {
        let className = this.props.size === SIZE.A4 ? ' rpx-pagePattern-a4' : '';
        className += this.props.size === SIZE.A3 ? ' rpx-pagePattern-a3' : '';
        className += this.props.orientation === ORIENTATION.PORTRAIT ? ' rpx-pagePattern-portrait' : '';
        className +=
            this.props.orientation === ORIENTATION.LANDSCAPE ? ' rpx-pagePattern-landscape' : '';
        return _jsx("div", { className: 'rpx-pagePattern' + className, ref: this.props.reference });
    }
}
//# sourceMappingURL=pagepattern.js.map